<template>
  <woot-modal :show.sync="localShow" :on-close="onClose" size="medium">
    <woot-modal-header
      :header-title="$t('BULK_DELETE_CONTACTS.RESULTS.TITLE')"
    />
    <div class="px-6 pb-6">
      <p class="text-sm text-slate-700 dark:text-slate-200 mb-4">
        {{
          $t('BULK_DELETE_CONTACTS.RESULTS.SUMMARY', {
            deleted: results.deletedCount,
            notDeleted: results.notDeletedCount,
          })
        }}
      </p>

      <div v-if="skippedContacts.length" class="mb-4">
        <h4 class="text-sm font-medium text-slate-900 dark:text-slate-100 mb-2">
          {{ $t('BULK_DELETE_CONTACTS.RESULTS.SKIPPED_TITLE') }}
        </h4>
        <ul class="text-sm text-slate-600 dark:text-slate-300 list-disc pl-5">
          <li v-for="item in skippedContacts" :key="`skipped-${item.chatwootContactId}`">
            {{ formatContactResult(item) }}
          </li>
        </ul>
      </div>

      <div v-if="failedContacts.length">
        <h4 class="text-sm font-medium text-slate-900 dark:text-slate-100 mb-2">
          {{ $t('BULK_DELETE_CONTACTS.RESULTS.FAILED_TITLE') }}
        </h4>
        <ul class="text-sm text-slate-600 dark:text-slate-300 list-disc pl-5">
          <li v-for="item in failedContacts" :key="`failed-${item.chatwootContactId}`">
            {{ formatContactResult(item) }}
          </li>
        </ul>
      </div>

      <div class="flex justify-end mt-6">
        <woot-button @click="onClose">
          {{ $t('BULK_DELETE_CONTACTS.RESULTS.CLOSE') }}
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    results: {
      type: Object,
      default: () => ({
        deletedCount: 0,
        notDeletedCount: 0,
        results: [],
      }),
    },
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    skippedContacts() {
      return (this.results.results || []).filter(
        item => item.status === 'skipped'
      );
    },
    failedContacts() {
      return (this.results.results || []).filter(
        item => item.status === 'failed'
      );
    },
  },
  methods: {
    formatContactResult(item) {
      const id = item.chatwootContactId;
      const reason = item.reason || item.errorCode || '';
      if (item.status === 'skipped' && reason === 'HAS_ORDERS') {
        return this.$t('BULK_DELETE_CONTACTS.RESULTS.HAS_ORDERS', { id });
      }
      return this.$t('BULK_DELETE_CONTACTS.RESULTS.ITEM', { id, reason });
    },
    onClose() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
  },
};
</script>
